export const dotsData = {
  roofpartialcolored: {
    name: "سقف",
    color: "#608EF2",
    top: 47.5,
    right: 44,
  }, // 5% افت رنگ جزئی سقف
  roofcolored: {
    name: "سقف",
    color: "#FFC370",
    top: 47.5,
    right: 44,
  }, // 7% افت رنگ سقف
  roofchanged: {
    name: "سقف",
    color: "#F66B34",
    top: 47.5,
    right: 44,
  }, // 15% افت تعویض سقف
  leftsillcolored: {
    name: "سقف",
    color: "#608EF2",
    top: 47.5,
    right: 44,
  }, // 5% افت رنگ رکابه سمت سرنشین
  leftsillchanged: {
    name: "",
    color: "",
    top: 0,
    right: 0,
  }, // 10% افت تعویض رکابه سمت سرنشین
  leftsillDentOrdamage: {
    name: "",
    color: "",
    top: 0,
    right: 0,
  }, // 8% افت فرورفتگی یا آسیب دیدگی رکابه سمت سرنشین

  rightsillcolored: {
    name: "",
    color: "",
    top: 0,
    right: 0,
  }, // 5% افت رنگ رکابه سمت راننده
  rightsillchanged: {
    name: "",
    color: "",
    top: 0,
    right: 0,
  }, // 10% افت تعویض رکابه سمت راننده
  rightsillDentOrdamage: {
    name: "",
    color: "",
    top: 0,
    right: 0,
  }, // 8% افت فرورفتگی یا آسیب دیدگی رکابه سمت راننده

  leftfrontcolumncolored: {
    name: "",
    color: "",
    top: 0,
    right: 0,
  }, // 5% افت رنگ ستون سمت سرنشین جلو
  leftfrontcolumnchanged: {
    name: "",
    color: "",
    top: 0,
    right: 0,
  }, // 10% افت تعویض ستون سمت سرنشین جلو
  leftfrontcolumndentordamage: {
    name: "",
    color: "",
    top: 0,
    right: 0,
  }, // 8% افت فرورفتگی یا آسیب دیدگی ستون سمت سرنشین جلو

  leftbackcolumncolored: {
    name: "",
    color: "",
    top: 0,
    right: 0,
  }, // 5% افت رنگ ستون سمت سرنشین عقب
  leftbackcolumnchanged: {
    name: "",
    color: "",
    top: 0,
    right: 0,
  }, // 10% افت تعویض ستون سمت سرنشین عقب
  leftbackcolumndentordamage: {
    name: "",
    color: "",
    top: 0,
    right: 0,
  }, // 8% افت فرورفتگی یا آسیب دیدگی ستون سمت سرنشین عقب

  rightbackcolumncolored: {
    name: "",
    color: "",
    top: 0,
    right: 0,
  }, // 5% افت رنگ ستون سمت سرنشین عقب
  rightbackcolumnchanged: {
    name: "",
    color: "",
    top: 0,
    right: 0,
  }, // 10% افت تعویض ستون سمت سرنشین عقب
  rightbackcolumndentordamage: {
    name: "",
    color: "",
    top: 0,
    right: 0,
  }, // 8% افت فرورفتگی یا آسیب دیدگی ستون سمت سرنشین عقب

  passengersidecentercolumncolored: {
    name: "",
    color: "",
    top: 0,
    right: 0,
  }, // 5% افت رنگ ستون سمت سرنشین - وسط
  passengersidecentercolumnchanged: {
    name: "",
    color: "",
    top: 0,
    right: 0,
  }, // 10% افت تعویض ستون سمت سرنشین - وسط
  passengersidecentercolumndentordamage: {
    name: "",
    color: "",
    top: 0,
    right: 0,
  }, // 8% افت فرورفتگی یا آسیب دیدگی ستون سمت سرنشین - وسط

  driversidecentercolumncolored: {
    name: "",
    color: "",
    top: 0,
    right: 0,
  }, // 5% افت رنگ ستون سمت راننده - وسط
  driversidecentercolumnchanged: {
    name: "",
    color: "",
    top: 0,
    right: 0,
  }, // 10% افت تعویض ستون سمت راننده - وسط
  driversidecentercolumndentordamage: {
    name: "",
    color: "",
    top: 0,
    right: 0,
  }, // 8% افت فرورفتگی یا آسیب دیدگی ستون سمت راننده - وسط

  leftfrontfendercolored: {
    name: "گلگیر جلو راننده",
    color: "#FFC370",
    top: 77,
    right: 72,
  }, // 5% افت رنگ گلگیر جلو راننده
  leftfrontfenderchanged: {
    name: "گلگیر جلو راننده",
    color: "#F66B34",
    top: 77,
    right: 72,
  }, // 10% افت تعویض گلگیر جلو راننده
  leftfrontfenderdentordamage: {
    name: "گلگیر جلو راننده",
    color: "#FFC370",
    top: 77,
    right: 72,
  }, // 8% افت فرورفتگی یا آسیب دیدگی گلگیر جلو راننده

  rightfrontfendercolored: {
    name: "گلگیر جلو شاگرد",
    color: "#FFC370",
    top: 18,
    right: 72,
  }, // 5% افت رنگ گلگیر جلو شاگرد
  rightfrontfenderchanged: {
    name: "گلگیر جلو شاگرد",
    color: "#F66B34",
    top: 18,
    right: 72,
  }, // 10% افت تعویض گلگیر جلو شاگرد
  rightfrontfenderdentordamage: {
    name: "گلگیر جلو شاگرد",
    color: "#FFC370",
    top: 18,
    right: 72,
  }, // 8% افت فرورفتگی یا آسیب دیدگی گلگیر جلو شاگرد
  leftbackfendercolored: {
    name: "گلگیر عقب راننده",
    color: "#FFC370",
    top: 74,
    right: 26,
  }, // 5% افت رنگ گلگیر عقب راننده
  leftbackfenderchanged: {
    name: "گلگیر عقب راننده",
    color: "#F66B34",
    top: 74,
    right: 26,
  }, // 10% افت تعویض گلگیر عقب راننده
  leftbackfenderdentordamage: {
    name: "گلگیر عقب راننده",
    color: "#FFC370",
    top: 74,
    right: 26,
  }, // 8% افت فرورفتگی یا آسیب دیدگی گلگیر عقب راننده

  rightbackfendercolored: {
    name: "گلگیر عقب شاگرد",
    color: "#FFC370",
    top: 21,
    right: 26,
  }, // 5% افت رنگ گلگیر عقب شاگرد
  rightbackfenderchanged: {
    name: "گلگیر عقب شاگرد",
    color: "#F66B34",
    top: 21,
    right: 26,
  }, // 10% افت تعویض گلگیر عقب شاگرد
  rightbackfenderdentordamage: {
    name: "گلگیر عقب شاگرد",
    color: "#FFC370",
    top: 21,
    right: 26,
  }, // 8% افت فرورفتگی یا آسیب دیدگی گلگیر عقب شاگرد
  rightfrontdoorpartialcolored: {
    name: "درب جلو شاگرد",
    color: "#608EF2",
    top: 15,
    right: 56,
  }, // 3% افت رنگ جزئی درب جلو شاگرد
  rightfrontdoorcolored: {
    name: "درب جلو شاگرد",
    color: "#FFC370",
    top: 15,
    right: 56,
  }, // 5% افت رنگ درب جلو شاگرد
  rightfrontdoorchanged: {
    name: "درب جلو شاگرد",
    color: "#F66B34",
    top: 15,
    right: 56,
  }, // 10% افت تعویض درب جلو شاگرد
  rightfrontdentordamage: {
    name: "درب جلو شاگرد",
    color: "#FFC370",
    top: 15,
    right: 56,
  }, // 8% افت فرورفتگی یا آسیب دیدگی درب شاگرد
  rightfrontpaintlessdentrepair: {
    name: "درب جلو شاگرد",
    color: "#FFC370",
    top: 15,
    right: 56,
  }, // 5% افت صافکاری بدون رنگ درب شاگرد
  rightfronttouchuporscratchrepair: {
    name: "درب جلو شاگرد",
    color: "#608EF2",
    top: 15,
    right: 56,
  }, // 2% افت لیسه گیری یا قلم گیری درب شاگرد
  rightfrontscratches: {
    name: "درب جلو شاگرد",
    color: "#608EF2",
    top: 15,
    right: 56,
  }, // 1% افت به دلیل وجود خط و خش درب شاگرد
  rightfrontpaintburn: {
    name: "درب جلو شاگرد",
    color: "#FFC370",
    top: 15,
    right: 56,
  }, // 7% افت به دلیل سوختگی رنگ درب شاگرد
  leftfrontdoorpartialcolored: {
    name: "درب جلو راننده",
    color: "#608EF2",
    top: 80,
    right: 56,
  }, // 3% افت رنگ جزئی درب جلو راننده
  leftfrontdoorcolored: {
    name: "درب جلو راننده",
    color: "#FFC370",
    top: 80,
    right: 56,
  }, // 5% افت رنگ درب جلو راننده
  leftfrontdoorchanged: {
    name: "درب جلو راننده",
    color: "#F66B34",
    top: 80,
    right: 56,
  }, // 10% افت تعویض درب جلو راننده
  leftfrontdentordamage: {
    name: "درب جلو راننده",
    color: "#FFC370",
    top: 80,
    right: 56,
  }, // 8% افت فرورفتگی یا آسیب دیدگی درب جلو راننده
  leftfrontpaintlessdentrepair: {
    name: "درب جلو راننده",
    color: "#FFC370",
    top: 80,
    right: 56,
  }, // 5% افت صافکاری بدون رنگ درب جلو راننده
  leftfronttouchuporscratchrepair: {
    name: "درب جلو راننده",
    color: "#608EF2",
    top: 80,
    right: 56,
  }, // 2% افت لیسه گیری یا قلم گیری درب جلو راننده
  leftfrontscratches: {
    name: "درب جلو راننده",
    color: "#608EF2",
    top: 80,
    right: 56,
  }, // 1% افت به دلیل وجود خط و خش درب جلو راننده
  leftfrontpaintburn: {
    name: "درب جلو راننده",
    color: "#FFC370",
    top: 80,
    right: 56,
  }, // 7% افت به دلیل سوختگی رنگ درب جلو راننده
  leftbackdoorpartialcolored: {
    name: "درب عقب راننده",
    color: "#608EF2",
    top: 80,
    right: 40,
  }, // 3% افت رنگ جزئی درب عقب راننده
  leftbackdoorcolored: {
    name: "درب عقب راننده",
    color: "#FFC370",
    top: 80,
    right: 40,
  }, // 5% افت رنگ درب عقب راننده
  leftbackdoorchanged: {
    name: "درب عقب راننده",
    color: "#F66B34",
    top: 80,
    right: 40,
  }, // 10% افت تعویض درب عقب راننده
  leftbackdoordentordamage: {
    name: "درب عقب راننده",
    color: "#FFC370",
    top: 80,
    right: 40,
  }, // 8% افت فرورفتگی یا آسیب دیدگی درب عقب راننده
  leftbackdoorpaintlessdentrepair: {
    name: "درب عقب راننده",
    color: "#FFC370",
    top: 80,
    right: 40,
  }, // 5% افت صافکاری بدون رنگ درب عقب راننده
  leftbackdoortouchuporscratchrepair: {
    name: "درب عقب راننده",
    color: "#608EF2",
    top: 80,
    right: 40,
  }, // 2% افت لیسه گیری یا قلم گیری درب عقب راننده
  leftbackdoorscratches: {
    name: "درب عقب راننده",
    color: "#608EF2",
    top: 80,
    right: 40,
  }, // 1% افت به دلیل وجود خط و خش درب عقب راننده
  leftbackdoorpaintburn: {
    name: "درب عقب راننده",
    color: "#FFC370",
    top: 80,
    right: 40,
  }, // 7% افت به دلیل سوختگی رنگ درب عقب راننده
  rightbackdoorchanged: {
    name: "درب عقب شاگرد",
    color: "#F66B34",
    top: 15,
    right: 40,
  }, // 10% افت تعویض درب عقب شاگرد
  rightbackdoorpaintlessdentrepair: {
    name: "درب عقب شاگرد",
    color: "#FFC370",
    top: 15,
    right: 40,
  }, // 5% افت صافکاری بدون رنگ درب عقب راننده
  rightbackdoorpartialcolored: {
    name: "درب عقب شاگرد",
    color: "#608EF2",
    top: 15,
    right: 40,
  }, // 3% افت رنگ جزئی درب عقب شاگرد
  rightbackdoorcolored: {
    name: "درب عقب شاگرد",
    color: "#FFC370",
    top: 15,
    right: 40,
  }, // 5% افت رنگ درب عقب شاگرد
  rightbackdoordentordamage: {
    name: "درب عقب شاگرد",
    color: "#FFC370",
    top: 15,
    right: 40,
  }, // 8% افت فرورفتگی یا آسیب دیدگی درب عقب راننده
  rightbackdoortouchuporscratchrepair: {
    name: "درب عقب شاگرد",
    color: "#608EF2",
    top: 15,
    right: 40,
  }, // 2% افت لیسه گیری یا قلم گیری درب عقب راننده
  rightbackdoorscratches: {
    name: "درب عقب شاگرد",
    color: "#608EF2",
    top: 15,
    right: 40,
  }, // 1% افت به دلیل وجود خط و خش درب عقب راننده
  rightbackdoorpaintburn: {
    name: "درب عقب شاگرد",
    color: "#FFC370",
    top: 15,
    right: 40,
  }, // 7% افت به دلیل سوختگی رنگ درب عقب راننده
  // 7% افت به دلیل سوختگی رنگ کاپوت
  hoodpartialcolored: {
    name: "کاپوت",
    color: "#608EF2",
    top: 47.5,
    right: 77,
  }, // 4% افت رنگ جزئی کاپوت
  hoodcolored: {
    name: "کاپوت",
    color: "#FFC370",
    top: 47.5,
    right: 77,
  }, // 6% افت رنگ کاپوت
  hoodchanged: {
    name: "کاپوت",
    color: "#F66B34",
    top: 47.5,
    right: 77,
  }, // 12% افت تعویض کاپوت
  hooddentordamage: {
    name: "کاپوت",
    color: "#FFC370",
    top: 47.5,
    right: 77,
  }, // 8% افت فرورفتگی یا آسیب دیدگی کاپوت
  hoodpaintlessdentrepair: {
    name: "کاپوت",
    color: "#FFC370",
    top: 47.5,
    right: 77,
  }, // 5% افت صافکاری بدون رنگ کاپوت
  hoodtouchuporscratchrepair: {
    name: "کاپوت",
    color: "#608EF2",
    top: 47.5,
    right: 77,
  }, // 2% افت لیسه گیری یا قلم گیری کاپوت
  hoodscratches: {
    name: "کاپوت",
    color: "#608EF2",
    top: 47.5,
    right: 77,
  }, // 1% افت به دلیل وجود خط و خش کاپوت
  hoodpaintburn: {
    name: "کاپوت",
    color: "#FFC370",
    top: 47.5,
    right: 77,
  }, // 7% افت به دلیل سوختگی رنگ کاپوت
  trunkpartialcolored: {
    name: "صندوق",
    color: "#608EF2",
    top: 47.5,
    right: 17,
  }, // 4% افت رنگ جزئی صندوق
  trunkcolored: {
    name: "صندوق",
    color: "#FFC370",
    top: 47.5,
    right: 17,
  }, // 6% افت رنگ صندوق
  trunkchanged: {
    name: "صندوق",
    color: "#F66B34",
    top: 47.5,
    right: 17,
  }, // 12% افت تعویض صندوق
  trunkdentordamage: {
    name: "صندوق",
    color: "#FFC370",
    top: 47.5,
    right: 17,
  }, // 8% افت فرورفتگی یا آسیب دیدگی صندوق
  trunkpaintlessdentrepair: {
    name: "صندوق",
    color: "#FFC370",
    top: 47.5,
    right: 17,
  }, // 5% افت صافکاری بدون رنگ صندوق
  trunktouchuporscratchrepair: {
    name: "صندوق",
    color: "#608EF2",
    top: 47.5,
    right: 17,
  }, // 2% افت لیسه گیری یا قلم گیری صندوق
  trunkscratches: {
    name: "صندوق",
    color: "#608EF2",
    top: 47.5,
    right: 17,
  }, // 1% افت به دلیل وجود خط و خش صندوق
  trunkpaintburn: {
    name: "صندوق",
    color: "#FFC370",
    top: 47.5,
    right: 17,
  }, // 7% افت به دلیل سوختگی رنگ صندوق
  rightfrontchassisminordamaged: {
    name: "شاسی جلو شاگرد",
    color: "#608EF2",
    top: 62,
    right: 90,
  }, // 5% افت آسیب جزئی شاسی جلو شاگرد
  rightfrontchassiscolored: {
    name: "شاسی جلو شاگرد",
    color: "#FFC370",
    top: 62,
    right: 90,
  }, // 7% افت رنگ شاسی جلو شاگرد
  rightfrontchassischanged: {
    name: "شاسی جلو شاگرد",
    color: "#F66B34",
    top: 62,
    right: 90,
  }, // 12% افت تعویض شاسی جلو شاگرد

  leftbackchassisminordamaged: {
    name: "شاسی عقب شاگرد",
    color: "#608EF2",
    top: 62,
    right: 6.5,
  }, // 5% افت آسیب جزئی شاسی عقب راننده
  leftbackchassiscolored: {
    name: "شاسی عقب شاگرد",
    color: "#FFC370",
    top: 62,
    right: 6.5,
  }, // 7% افت رنگ شاسی عقب راننده
  leftbackchassischanged: {
    name: "شاسی عقب شاگرد",
    color: "#F66B34",
    top: 62,
    right: 6.5,
  }, // 12% افت تعویض شاسی عقب راننده

  leftfrontchassisminordamaged: {
    name: "شاسی جلو راننده",
    color: "#608EF2",
    top: 33,
    right: 90,
  }, // 5% افت آسیب جزئی شاسی جلو راننده
  leftfrontchassiscolored: {
    name: "شاسی جلو راننده",
    color: "#FFC370",
    top: 33,
    right: 90,
  }, // 7% افت رنگ شاسی جلو راننده
  leftfrontchassischanged: {
    name: "شاسی جلو راننده",
    color: "#F66B34",
    top: 33,
    right: 90,
  }, // 12% افت تعویض شاسی جلو راننده

  rightbackchassisminordamaged: {
    name: "شاسی عقب شاگرد",
    color: "#608EF2",
    top: 62,
    right: 6.5,
  }, // 5% افت آسیب جزئی شاسی عقب شاگرد
  rightbackchassiscolored: {
    name: "شاسی عقب شاگرد",
    color: "#FFC370",
    top: 62,
    right: 6.5,
  }, // 7% افت رنگ شاسی عقب شاگرد
  rightbackchassischanged: {
    name: "شاسی عقب شاگرد",
    color: "#F66B34",
    top: 62,
    right: 6.5,
  }, // 12% افت تعویض شاسی عقب شاگرد

  frontsparewheelareadentordamage: {
    name: "",
    color: "",
    top: 0,
    right: 0,
  }, // 8% افت فرورفتگی یا آسیب دیدگی محوطه چرخ زاپاس
  fronthealthhasnoappearance: {
    name: "",
    color: "",
    top: 0,
    right: 0,
  }, // 8% افت فرورفتگی یا آسیب دیدگی محوطه چرخ زاپاس
  backsparewheelareadentordamage: {
    name: "",
    color: "",
    top: 0,
    right: 0,
  }, // 8% افت فرورفتگی یا آسیب دیدگی محوطه چرخ زاپاس
  backhealthhasnoappearance: {
    name: "",
    color: "",
    top: 0,
    right: 0,
  }, // 8% افت فرورفتگی یا آسیب دیدگی محوطه چرخ زاپاس
  TheCarRoomIsChanging: {
    name: "",
    color: "",
    top: 0,
    right: 0,
  },
};
export const orderHistoryTabData = [
  {
    label: "جاری",
    value: [
      { name: "در حال پردازش", id: "pending", color: "#FFCF0E" },
      { name: "ارسال شده", id: "posted", color: "#22A137" },
      { name: "در حال ارسال", id: "delivered", color: "#1E67BF" },
      { name: "در انتظار پرداخت", id: "waiting_payment", color: "#FE9D00" },
    ],
  },
  {
    label: "انجام شده",
    value: [{ name: "انجام شده", id: "accept", color: "#22A137" }],
  },
  {
    label: "لغو شده",
    value: [{ name: "لغو شده", id: "canceled", color: "#DB3737" }],
  },
];
